import duration from "./duration.filter";

const durationModule = angular
  .module("app.filters.duration", [])
  .filter("duration", duration);

export default durationModule;



// WEBPACK FOOTER //
// ./src/filters/duration/duration.module.js